<template>
    <div>
        <template v-for="(item, index) in items">

            <!-- control_item -->
            <div v-if="item.type == 3" class="row control_item underlined_item" :id="'payer-' + item.id">
                <div class="col-12 col-md-9 col-xl-10 mt_xxs">
                    <div class="media control_group">
                        <div class="control_action">
                            <button
                                v-if="checkable"
                                href="#"
                                class="btn btn_lg btn_common btn_icontext"
                                @click.prevent="
                                    choosePayer(item.id, item.name, item.type)
                                "
                            >
                                <i class="f7-icons icon_lg">
                                    {{
                                        payer.id == item.id
                                            ? "checkmark_alt_circle_fill"
                                            : "checkmark_alt_circle"
                                    }}
                                </i>
                                {{
                                    payer.id == item.id ? "Выбрано" : "Выбрать"
                                }}
                            </button>
                        </div>

                        <div class="media-body">
                            <div class="control_title subtitle">
                                {{ item.name }}
                            </div>

                            <div class="control_small small_info">
                                <span class="other_xs">Физическое лицо.</span>
                                <span v-if="item.discount" class="sale_xs">Скидка {{ item.discount }}% постоянному клиенту.</span>
                            </div>
                            <!--
                            <div
                                class="control_info item_info item_info_horizontal"
                            >
                                <p>
                                    <span>Пол</span>
                                    {{ item.gender == "male" ? "М" : "Ж" }}
                                </p>
                                <p>
                                    <span>Дата рождения</span>
                                    {{ item.birth_date }}
                                </p>
                            </div>
                            <div
                                class="control_info item_info item_info_horizontal"
                            >
                                <p>
                                    <span>Номер удостоверения</span>
                                    {{ item.doc_number }}
                                </p>
                                <p><span>Выдан</span> {{ item.doc_date }}</p>
                                <p>
                                    <span>Действителен</span>
                                    {{ item.doc_expired }}
                                </p>
                            </div>
                            -->
                            <div
                                class="control_info item_info item_info_horizontal"
                            >
                                <p><span>Телефон</span> {{ item.phone }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3 col-xl-2 mt_xxs">
                    <div class="control_change">
                        <div>
                            <button
                                type="button"
                                class="btn btn_sm btn_neutral btn_icontext"
                                @click.prevent="editPayer(item.id)"
                            >
                                <i class="f7-icons icon_sm">pencil</i>Правка
                            </button>
                        </div>
                        <div>
                            <button
                                class="btn btn_sm btn_neutral"
                                @click.prevent="deletePayer(item.id)"
                            >
                                Удалить
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- //control_item -->

            <!-- control_item -->
            <div v-if="item.type == 2" class="row control_item underlined_item" :id="'payer-' + item.id">
                <div class="col-12 col-md-9 col-xl-10 mt_xxs">
                    <div class="media control_group">
                        <div class="control_action">
                            <button
                                v-if="checkable"
                                href="#"
                                class="btn btn_lg btn_common btn_icontext"
                                @click.prevent="
                                    choosePayer(item.id, item.name, item.type)
                                "
                            >
                                <i class="f7-icons icon_lg">
                                    {{
                                        payer.id == item.id
                                            ? "checkmark_alt_circle_fill"
                                            : "checkmark_alt_circle"
                                    }}
                                </i>
                                {{
                                    payer.id == item.id ? "Выбрано" : "Выбрать"
                                }}
                            </button>
                        </div>

                        <div class="media-body">
                            <div class="control_title subtitle">
                                {{ item.name }}
                            </div>

                            <div class="control_small small_info">
                                <span class="other_xs">Индивидиальный предприниматель.</span>
                                <span v-if="item.discount" class="sale_xs">Скидка {{ item.discount }}% постоянному клиенту.</span>
                            </div>
                            <div
                                class="control_info item_info item_info_horizontal"
                            >
                                <p v-if="item.ogrnip"><span>ОГРНИП</span> {{ item.ogrnip }}</p>
                                <p v-if="item.inn"><span>ИНН</span> {{ item.inn }}</p>
                            </div>
                            <div
                                class="control_info item_info item_info_horizontal"
                            >
                                <p v-if="item.reg_cert">
                                    <span>Свидетельство о регистрации</span>
                                    {{ item.reg_cert }}
                                </p>
                                <p v-if="item.reg_date">
                                    <span>Дата регистрации</span>
                                    {{ item.reg_date }}
                                </p>
                            </div>
                            <div
                                class="control_info item_info item_info_horizontal"
                            >
                                <p><span>Телефон</span> {{ item.phone }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3 col-xl-2 mt_xxs">
                    <div class="control_change">
                        <div>
                            <button
                                type="button"
                                class="btn btn_sm btn_neutral btn_icontext"
                                @click.prevent="editPayer(item.id)"
                            >
                                <i class="f7-icons icon_sm">pencil</i>Правка
                            </button>
                        </div>
                        <div>
                            <button
                                class="btn btn_sm btn_neutral"
                                @click.prevent="deletePayer(item.id)"
                            >
                                Удалить
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- //control_item -->

            <!-- control_item -->
            <div v-if="item.type == 1" class="row control_item underlined_item" :id="'payer-' + item.id">
                <div class="col-12 col-md-9 col-xl-10 mt_xxs">
                    <div class="media control_group">
                        <div class="control_action">
                            <button
                                v-if="checkable"
                                href="#"
                                class="btn btn_lg btn_common btn_icontext"
                                @click.prevent="
                                    choosePayer(item.id, item.name, item.type)
                                "
                            >
                                <i class="f7-icons icon_lg">
                                    {{
                                        payer.id == item.id
                                            ? "checkmark_alt_circle_fill"
                                            : "checkmark_alt_circle"
                                    }}
                                </i>
                                {{
                                    payer.id == item.id ? "Выбрано" : "Выбрать"
                                }}
                            </button>
                        </div>

                        <div class="media-body">
                            <div class="control_title subtitle">
                                {{ item.name }}
                            </div>

                            <div class="control_small small_info">
                                <span class="other_xs">Юридическое лицо.</span>
                                <span v-if="item.discount" class="sale_xs">Скидка {{ item.discount }}% постоянному клиенту.</span>
                            </div>
                            <div
                                class="control_info item_info item_info_horizontal"
                            >
                                <p v-if="item.inn"><span>ИНН</span> {{ item.inn }}</p>
                                <p v-if="item.kpp"><span>КПП</span> {{ item.kpp }}</p>
                                <p v-if="item.address">
                                    <span>Адрес регистрации</span>
                                    {{ item.address }}
                                </p>
                                <p v-if="item.postal_address">
                                    <span>Почтовый адрес</span>
                                    {{ item.postal_address }}
                                </p>
                            </div>
                            <div
                                class="control_info item_info item_info_horizontal"
                            >
                                <p v-if="item.rs"><span>Р/С</span> {{ item.rs }}</p>
                                <p v-if="item.bank"><span>Банк</span> {{ item.bank }}</p>
                                <p v-if="item.bik"><span>БИК</span> {{ item.bik }}</p>
                                <p v-if="item.ks"><span>К/С</span> {{ item.ks }}</p>
                            </div>
                            <div
                                class="control_info item_info item_info_horizontal"
                            >
                                <p><span>Телефон</span> {{ item.phone }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3 col-xl-2 mt_xxs">
                    <div class="control_change">
                        <div>
                            <button
                                type="button"
                                class="btn btn_sm btn_neutral btn_icontext"
                                @click.prevent="editPayer(item.id)"
                            >
                                <i class="f7-icons icon_sm">pencil</i>Правка
                            </button>
                        </div>
                        <div>
                            <button
                                class="btn btn_sm btn_neutral"
                                @click.prevent="deletePayer(item.id)"
                            >
                                Удалить
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- //control_item -->
        </template>

        <b-alert
            v-model="showSuccess"
            class="position-fixed fixed-top m-0 rounded-0"
            style="z-index: 2000;"
            variant="success"
            dismissible
        >
            Изменения сохранены.
        </b-alert>
    </div>
</template>

<script>
export default {
    props: {
        checkable: {
            default: true,
            type: Boolean,
        }
    },
    data: function () {
        return {
            showSuccess: false
        };
    },
    methods: {
        deletePayer(id) {
            this.$store.dispatch("payer/deletePayer", id);

            // Если удаляемый плательщик является выбранным, сбрасываем выбранного плательщика
            if (this.payer.id == id) {
                this.$store.dispatch("order/choosePayer", {
                    id: null,
                    name: "",
                });
            }
        },

        editPayer(id) {
            this.$store.dispatch("payer/getPayer", id);
            document
                .getElementById("editPayerForm")
                .scrollIntoView({ behavior: "smooth" });
        },

        choosePayer(id, name, type) {
            this.$store.dispatch("order/choosePayer", { id, name, type });
            document.getElementById("modalPayerClose").click();
        },
    },
    computed: {
        // Массив плательщиков
        items() {
            return this.$store.state.payer.payers;
        },

        // Выбранный плательщик
        payer() {
            return this.$store.state.order.payer;
        },
    },

    updated: function() {
        //TODO: Может, убрать getElementById?
        // Если какой-то элемент был создан/отредактирован
        if (this.$store.state.payer.lastId 
            && document.getElementById('payer-' + this.$store.state.payer.lastId)
        ) {
            // Сообщение об удачном сохранении
            this.showSuccess = true;
            setTimeout(() => this.showSuccess = false, 3000);

            // Скролл к отредактированному/созданному элементу
            let el = document.getElementById('payer-' + this.$store.state.payer.lastId);
            
            if (el) {
                el.classList.add('highlighted');
                el.scrollIntoView({ behavior: "smooth" });                

                // setTimeout(() => el.classList.remove('highlighted'), 5000);
            }

            this.$store.commit('payer/setLastId', null);
        }
    }
};
</script>
